import { c as _c } from "react/compiler-runtime";
import DateRangeIcon from '@mui/icons-material/DateRange';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import { parse } from '@openclassrooms/date-time/duration';
import Typography from '@classify/react-core-components/Typography';
import ProductMetadata, { Props as ProductMetadataProps } from '../ProductMetadata';
import defaultTranslations, { TranslationsProp } from './defaultTranslations';
export interface Props extends Omit<ProductMetadataProps, 'variant' | 'children'> {
  duration: string;
  translations?: TranslationsProp;
  accessibilityLabel: string;
}
const ProductMetadataDuration = t0 => {
  const $ = _c(25);
  let accessibilityLabel;
  let duration;
  let icon;
  let otherProps;
  let overTitle;
  let sx;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      sx,
      accessibilityLabel,
      duration,
      icon,
      overTitle,
      shouldNotWrap: t1,
      translations: t2,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = accessibilityLabel;
    $[2] = duration;
    $[3] = icon;
    $[4] = otherProps;
    $[5] = overTitle;
    $[6] = sx;
    $[7] = t1;
    $[8] = t2;
  } else {
    accessibilityLabel = $[1];
    duration = $[2];
    icon = $[3];
    otherProps = $[4];
    overTitle = $[5];
    sx = $[6];
    t1 = $[7];
    t2 = $[8];
  }
  const shouldNotWrap = t1 === undefined ? false : t1;
  const translations = t2 === undefined ? defaultTranslations : t2;
  let content;
  let months;
  let t3;
  let yearsInMonths;
  if ($[9] !== duration || $[10] !== translations) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const {
        years: t4,
        months: t5,
        hours: t6,
        minutes: t7
      } = duration ? parse(duration) : {};
      const years = t4 === undefined ? 0 : t4;
      months = t5 === undefined ? 0 : t5;
      const hours = t6 === undefined ? 0 : t6;
      const minutes = t7 === undefined ? 0 : t7;
      const hasDurationData = Boolean(years) || Boolean(months) || Boolean(hours) || Boolean(minutes);
      if (!hasDurationData) {
        t3 = null;
        break bb0;
      }
      yearsInMonths = 0;
      if (years) {
        yearsInMonths = years * 12;
      }
      if (months || yearsInMonths) {
        content = translations.durationMonths?.(months + yearsInMonths);
      } else {
        if (hours) {
          content = translations.durationHours?.(hours) ?? "";
        } else {
          content = translations.durationMinutes?.(minutes) ?? "";
        }
      }
    }
    $[9] = duration;
    $[10] = translations;
    $[11] = content;
    $[12] = months;
    $[13] = t3;
    $[14] = yearsInMonths;
  } else {
    content = $[11];
    months = $[12];
    t3 = $[13];
    yearsInMonths = $[14];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  if (!content) {
    return null;
  }
  const computedIcon = icon ?? (months || yearsInMonths ? DateRangeIcon : QueryBuilderIcon);
  let t4;
  if ($[15] !== content) {
    t4 = <Typography variant="bodySmall" dangerouslySetInnerHTML={{
      __html: content
    }} />;
    $[15] = content;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== accessibilityLabel || $[18] !== computedIcon || $[19] !== otherProps || $[20] !== overTitle || $[21] !== shouldNotWrap || $[22] !== sx || $[23] !== t4) {
    t5 = <ProductMetadata icon={computedIcon} accessibilityLabel={accessibilityLabel} shouldNotWrap={shouldNotWrap} sx={sx} overTitle={overTitle} {...otherProps}>{t4}</ProductMetadata>;
    $[17] = accessibilityLabel;
    $[18] = computedIcon;
    $[19] = otherProps;
    $[20] = overTitle;
    $[21] = shouldNotWrap;
    $[22] = sx;
    $[23] = t4;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  return t5;
};
export default ProductMetadataDuration;